import posthog from 'posthog-js';

let isInitialized = false;

export function initializePostHog() {
  if (isInitialized) {
    return posthog;
  }

  const projectToken = process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN;
  const host = process.env.NEXT_PUBLIC_POSTHOG_HOST;

  if (!projectToken || !host) {
    throw new Error(
      'PostHog requires NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN and NEXT_PUBLIC_POSTHOG_HOST'
    );
  }

  posthog.init(projectToken, {
    api_host: host,
    defaults: '2026-05-30',
  });
  isInitialized = true;

  return posthog;
}
